import script from "./fileUploadMarket.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUploadMarket.vue?vue&type=script&setup=true&lang=js"

import "./fileUploadMarket.vue?vue&type=style&index=0&id=3f8be2ce&lang=scss"

const __exports__ = script;

export default __exports__